import { firestore } from "config/firebase/firebase";
import { OrderConverter } from "@medlog/shared/helpers/Converters";

const getOrder = async (uid: string) => {
  const docSnap = await firestore.collection("orders").doc(uid).withConverter(OrderConverter).get();
  return docSnap.data()
};

export default getOrder;
